var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-settings__card"},[_c('h2',{staticClass:"header-2"},[_vm._v(" Imagine și videoclip profil ")]),_c('FormUpdateImageAndVideo',{on:{"activeButton":function($event){_vm.activeNextStep = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }